const countUp = (element) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const duration = 1000;
  const start = new Date().getTime();
  const target = Number(element.getAttribute('data-count'));
  element.removeAttribute('data-count');

  const runAnimation = () => {
    const progress = Math.min((new Date().getTime() - start) / duration, 1);
    element.textContent = progress === 1
      ? `${target.toLocaleString('el-GR')}+`
      : Math.floor(progress * target).toLocaleString('el-GR');

    if (progress < 1) {
      requestAnimationFrame(runAnimation);
    }
  };

  requestAnimationFrame(runAnimation);
};

export const initTransitions = () => {
  const elements = Array.from(
    document.querySelectorAll(
      '.transition-fade, .transition-left, .transition-right, .transition-up, .transition-expand, [data-count]',
    ),
  );
  let remainingElements = elements.length;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target.hasAttribute('data-count')) {
            countUp(entry.target);
          } else {
            entry.target.classList.add('transition-show');
          }

          remainingElements--;
          observer.unobserve(entry.target);
        }
      });

      if (remainingElements === 0) {
        observer.disconnect();
      }
    },
    {
      threshold: 0.1,
    },
  );

  elements.forEach((el) => observer.observe(el));
};
